import "core-js/modules/es.array.concat.js";
import React from 'react';
import { map } from 'lodash';
import { Statuses, Status, Icon } from "./styles";
import { BottomText } from "../../style/CommonStyles";
import { statusSelector, isPaidSelector, verificationPendingSelector } from '@applyboard/ab-common';
import { GOOD_STATE, NORMAL_STATE, WARNING_STATE, BAD_STATE } from "../../style/colors";
import { CheckMarkOutlineIcon, CloseOutlineIcon, HourglassHalfOutlineIcon, ShoppingCartOutlineIcon, WarningFillIcon } from '@applyboard/ui-icons';
export var ApplicationStatus = function ApplicationStatus(_ref) {
  var _application$status, _application$status2, _application$status3, _application$status4, _application$status5;
  var application = _ref.application;
  var statuses = getStatus(application);
  return /*#__PURE__*/React.createElement(Statuses, null, map(statuses, function (status) {
    return /*#__PURE__*/React.createElement(Status, {
      key: "".concat(status.icon, "-").concat(status.label),
      color: status.color
    }, (status === null || status === void 0 ? void 0 : status.icon) && /*#__PURE__*/React.createElement(Icon, null, status.icon), /*#__PURE__*/React.createElement("div", null, status.label));
  }), (application === null || application === void 0 ? void 0 : (_application$status = application.status) === null || _application$status === void 0 ? void 0 : _application$status.enrollment_confirmed) && /*#__PURE__*/React.createElement(BottomText, null, "Enrollment Confirmed"), (application === null || application === void 0 ? void 0 : (_application$status2 = application.status) === null || _application$status2 === void 0 ? void 0 : _application$status2.ready_to_enroll) && /*#__PURE__*/React.createElement(BottomText, null, "Ready To Enroll"), (application === null || application === void 0 ? void 0 : (_application$status3 = application.status) === null || _application$status3 === void 0 ? void 0 : _application$status3.ready_for_visa) && /*#__PURE__*/React.createElement(BottomText, null, "Ready for Visa"), (application === null || application === void 0 ? void 0 : (_application$status4 = application.status) === null || _application$status4 === void 0 ? void 0 : _application$status4.ready_to_submit) && /*#__PURE__*/React.createElement(BottomText, null, "Ready to Submit"), (application === null || application === void 0 ? void 0 : (_application$status5 = application.status) === null || _application$status5 === void 0 ? void 0 : _application$status5.submitted) && /*#__PURE__*/React.createElement(BottomText, null, "Submitted to School"));
};
var getStatus = function getStatus(application) {
  var statuses = [];
  var applicationStatuses = statusSelector(application);
  if (!applicationStatuses) {
    return [];
  }
  if (applicationStatuses.accepted) {
    statuses.push({
      icon: /*#__PURE__*/React.createElement(CheckMarkOutlineIcon, null),
      label: 'Accepted',
      color: GOOD_STATE
    });
  } else if (applicationStatuses.rejected) {
    statuses.push({
      icon: /*#__PURE__*/React.createElement(CloseOutlineIcon, null),
      label: 'Rejected',
      color: BAD_STATE
    });
  } else if (applicationStatuses.waitlisted) {
    statuses.push({
      label: 'Waitlisted',
      color: BAD_STATE
    });
  } else if (applicationStatuses.program_closed) {
    statuses.push({
      label: 'Program Closed',
      color: BAD_STATE
    });
  }
  if (applicationStatuses.refund_in_progress) {
    statuses.push({
      icon: /*#__PURE__*/React.createElement(HourglassHalfOutlineIcon, null),
      label: 'Refund in Progress',
      color: WARNING_STATE
    });
  } else if (applicationStatuses.deferral_in_progress) {
    statuses.push({
      icon: /*#__PURE__*/React.createElement(HourglassHalfOutlineIcon, null),
      label: 'Deferral in Progress',
      color: WARNING_STATE
    });
  } else if (applicationStatuses.withdrawn) {
    statuses.push({
      icon: /*#__PURE__*/React.createElement(WarningFillIcon, null),
      label: 'Withdrawn',
      color: WARNING_STATE
    });
  } else if (applicationStatuses.canceled) {
    statuses.push({
      icon: /*#__PURE__*/React.createElement(WarningFillIcon, null),
      label: 'Canceled',
      color: WARNING_STATE
    });
  }
  if (statuses.length === 0) {
    if (isPaidSelector(application)) {
      statuses.push({
        icon: /*#__PURE__*/React.createElement(HourglassHalfOutlineIcon, null),
        label: 'Processing',
        color: NORMAL_STATE
      });
    } else if (verificationPendingSelector(application)) {
      statuses.push({
        icon: /*#__PURE__*/React.createElement(HourglassHalfOutlineIcon, null),
        label: 'Pending Verification',
        color: WARNING_STATE
      });
    } else {
      statuses.push({
        icon: /*#__PURE__*/React.createElement(ShoppingCartOutlineIcon, null),
        label: 'Payment Pending',
        color: NORMAL_STATE
      });
    }
  }
  return statuses;
};